<template>
  <FlexCol gap-1>
    <Label :label="label" :required="required" :error="error" v-if="label" />
    <Input v-model="localValue" :error="error" :placeholder="placeholder ? placeholder : 'Digite o ano'" :disabled="disabled" mask="####" @enter="normalizeAndEmit(localValue)" />
    <Error :message="error" v-if="error" />
  </FlexCol>
</template>

<script setup>
import { ref, watch } from 'vue'

const props = defineProps({
  label: String,
  required: Boolean,
  disabled: Boolean,
  error: Array,
  modelValue: [String, Number],
  placeholder: String,
  min: { type: Number, default: 1900 },
  max: { type: Number, default: () => new Date().getFullYear() + 10 },
})

const emits = defineEmits(['update:modelValue'])

const error = ref(props.error)
const localValue = ref(props.modelValue ? String(props.modelValue).replace(/\D/g, '').slice(0, 4) : null)

const clampYear = (year) => {
  if (!Number.isInteger(year)) return null
  if (year < props.min) return props.min
  if (year > props.max) return props.max
  return year
}

const normalizeAndEmit = (value) => {
  if (value === null || value === undefined || value === '') {
    emits('update:modelValue', null)
    return
  }

  const digits = String(value).replace(/\D/g, '').slice(0, 4)
  localValue.value = digits

  if (digits.length < 4) {
    emits('update:modelValue', digits)
    return
  }

  const parsed = clampYear(Number(digits))
  localValue.value = parsed ? String(parsed) : null
  emits('update:modelValue', parsed)
}

watch(
  () => props.modelValue,
  (newValue) => {
    localValue.value = newValue ? String(newValue).replace(/\D/g, '').slice(0, 4) : null
  },
)

watch(
  () => props.error,
  (newValue) => {
    error.value = newValue
  },
)

watch(localValue, (newValue) => {
  normalizeAndEmit(newValue)
})
</script>
